
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/create",
      function () {
        return require("private-next-pages/brand/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/create"])
      });
    }
  